var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFailed = function SvgFailed(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_warning",
    "data-name": "icon warning",
    transform: "translate(-696.685 -479.929)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_151",
    "data-name": "Ellipse 151",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(696.685 479.929)",
    fill: "#c72525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M731.1,501.234a3.988,3.988,0,0,0-2.832,4.006c.088,1.159.161,2.332.249,3.492.25,4.417.5,8.745.749,13.161a2.69,2.69,0,0,0,2.744,2.583,2.742,2.742,0,0,0,2.743-2.671c0-.91,0-1.747.089-2.671.16-2.832.338-5.664.5-8.5.088-1.835.25-3.668.337-5.5a4.532,4.532,0,0,0-.337-1.835,3.677,3.677,0,0,0-4.24-2.068Zm0,0",
    transform: "translate(-2.324 -1.455)",
    fill: "#f5f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M732.014,528.866a3.669,3.669,0,0,0,0,7.337,3.67,3.67,0,0,0,0-7.337Zm0,0",
    transform: "translate(-2.33 -3.336)",
    fill: "#f5f7f9"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFailed, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NSIgaGVpZ2h0PSI2NSIgdmlld0JveD0iMCAwIDY1IDY1Ij4NCiAgPGcgaWQ9Imljb25fd2FybmluZyIgZGF0YS1uYW1lPSJpY29uIHdhcm5pbmciIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02OTYuNjg1IC00NzkuOTI5KSI+DQogICAgPGNpcmNsZSBpZD0iRWxsaXBzZV8xNTEiIGRhdGEtbmFtZT0iRWxsaXBzZSAxNTEiIGN4PSIzMi41IiBjeT0iMzIuNSIgcj0iMzIuNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjk2LjY4NSA0NzkuOTI5KSIgZmlsbD0iI2M3MjUyNSIvPg0KICAgIDxwYXRoIGlkPSJQYXRoXzYxOSIgZGF0YS1uYW1lPSJQYXRoIDYxOSIgZD0iTTczMS4xLDUwMS4yMzRhMy45ODgsMy45ODgsMCwwLDAtMi44MzIsNC4wMDZjLjA4OCwxLjE1OS4xNjEsMi4zMzIuMjQ5LDMuNDkyLjI1LDQuNDE3LjUsOC43NDUuNzQ5LDEzLjE2MWEyLjY5LDIuNjksMCwwLDAsMi43NDQsMi41ODMsMi43NDIsMi43NDIsMCwwLDAsMi43NDMtMi42NzFjMC0uOTEsMC0xLjc0Ny4wODktMi42NzEuMTYtMi44MzIuMzM4LTUuNjY0LjUtOC41LjA4OC0xLjgzNS4yNS0zLjY2OC4zMzctNS41YTQuNTMyLDQuNTMyLDAsMCwwLS4zMzctMS44MzUsMy42NzcsMy42NzcsMCwwLDAtNC4yNC0yLjA2OFptMCwwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMi4zMjQgLTEuNDU1KSIgZmlsbD0iI2Y1ZjdmOSIvPg0KICAgIDxwYXRoIGlkPSJQYXRoXzYyMCIgZGF0YS1uYW1lPSJQYXRoIDYyMCIgZD0iTTczMi4wMTQsNTI4Ljg2NmEzLjY2OSwzLjY2OSwwLDAsMCwwLDcuMzM3LDMuNjcsMy42NywwLDAsMCwwLTcuMzM3Wm0wLDAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yLjMzIC0zLjMzNikiIGZpbGw9IiNmNWY3ZjkiLz4NCiAgPC9nPg0KPC9zdmc+DQo=";
export { ForwardRef as ReactComponent };